<template>
  <div>
   <!--  <v-btn block class="info rounded-pill my-4" @click.stop="dialogForm = true">
      <v-icon class="mr-4">mdi-chart-gantt</v-icon>Assigner Campagne
    </v-btn> -->
    <v-dialog
      v-model="dialogForm"
      fullscreen
      hide-overlay
      transition="slide-x-transition"
    >
      <v-card>
        <v-app-bar class="transparent" light flat>
          <v-toolbar-title>
            <v-btn icon @click="reset">
              <v-icon>mdi-arrow-left</v-icon>
            </v-btn>
            Campagnes : {{ groupe.nom_groupe }}
          </v-toolbar-title>
        </v-app-bar>
        <v-card-text>
          <v-form ref="form" lazy-validation>
            <v-container fluid>
              <v-row no-gutters>
                <v-col cols="12">
                  <v-select
                    v-model="campagnesExistantesData"
                    :items="_.union(CampagnesCreeparAdmin, campagnesExistantes)"
                    attach
                    chips
                    label="Campagnes"
                    multiple
                    outlined
                  ></v-select>
                </v-col>
              </v-row>
            </v-container>
          </v-form>
        </v-card-text>
        <v-card-actions class="pb-4">
          <v-btn class="rounded-pill neumorphic warning" @click="reset"
            >Annuler</v-btn
          >
          <v-btn
            class="rounded-pill neumorphic primary"
            :loading="newLoading"
            @click="setCampagnes()"
            >Assigner la campagne</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
export default {
  created() {
    this.GetActivites();
  },
  data() {
    return {
      campagnesExistantesData: this.campagnesExistantes,
      bailleur_selected: "",
      projet_selected: "",
      activite_selected: "",
      projets: [],
      activites: [],
      menu2: false,
      date_debut: "",
      date_fin: "",
      newLoading: false,
      dialogForm: false,
      requis: [
        (v) => !!v || "Ce champ est obligatoire",
        (v) => (v && v.length >= 3) || "Au moins trois caractères",
      ],
      emailRules: [
        (v) => !!v || "E-mailrequis",
        (v) => /.+@.+\..+/.test(v) || "E-mail invalide",
      ],
      selectRules: [(v) => !!v || "Veuillez sélectionner une valeur"],
      ll_parcours_effectif: "",
    };
  },
  props: {
    groupe: {
      type: Object,
      required: true,
    },
    CampagnesCreeparAdmin: {
      type: Array,
      required: true,
    },
    campagnesExistantes: {
      type: Array,
      required: true,
    },
  },
  methods: {
    create(projet, ll_parcours_effectif, ll_mois, Activite) {
      let uuid = "0000aaaa-" + this.$uuid.v4();
      var self = this;
      this.newLoading = true;
      var newCampagne = {
        //parametres
        id: uuid,
        ll_parcours_effectif: ll_parcours_effectif,
        ll_mois: ll_mois,
        date_debut: ll_mois + " 00:00:00",
        //projet
        programmes_id_programme: projet.id_programme,
        ll_programme: projet.ll_programme,
        id_bailleur: projet.id_bailleur,
        ll_bailleur: projet.ll_bailleur,
        abbr_bailleur: projet.abbr_bailleur,
        //groupe
        groupes_id_groupe: this.groupe.id_groupe,
        code_fokontany: this.groupe.code_fokontany,
        village: this.groupe.village,
        nom_groupe: this.groupe.nom_groupe,
        id_responsable: this.groupe.responsable,
        latitude: this.groupe.latitude,
        longitude: this.groupe.longitude,
        nom_responsable: this.groupe.nom_responsable,
        ll_fokontany: this.groupe.ll_fokontany,
        id_commune: this.groupe.id_commune,
        ll_commune: this.groupe.ll_commune,
        id_district: this.groupe.id_district,
        ll_district: this.groupe.ll_district,
        id_region: this.groupe.id_region,
        ll_region: this.groupe.ll_region,
        //id_province: this.groupe.ll_province,
        //ll_province: this.groupe.ll_province,
        //ll_parcours
        ll_parcours: Activite[0].ll_parcours,
        abbr_parcours: Activite[0].abbr_parcours,
        parcours_id_parcours: Activite[0].id,
        description_parcours: Activite[0].description_parcours,
        themes_id_theme: Activite[0].themes_id_theme,
        ll_theme: Activite[0].ll_theme,
      };
      console.log(newCampagne);
      //Campagne
     /*  this.$firebase
        .firestore()
        .collection("parcours_effectif")
        .doc(uuid)
        .set(newCampagne, { merge: true });
      console.log("Campagne créée id: " + uuid);  */
    },
    reset() {
      this.communes = [];
      this.newLoading = false;
      this.dialogForm = false;
      this.campagnesExistantesData = this.campagnesExistantes;
    },
    setProjet() {
      let self = this;
      self.projets = [];

      this.$firebase
        .firestore()
        .collection("projets")
        .where("ll_bailleur", "==", this.bailleur_selected)
        .get()
        .then((snap) => {
          snap.forEach((doc) => {
            var projet = doc.data();
            projet.id = doc.id;

            self.projets.push({
              ...projet,
            });
          });
        });
    },
    setActivite() {
      let self = this;
      self.activites = [];
      this.$firebase
        .firestore()
        .collection("activites")
        .where("ll_programme", "==", this.projet_selected)
        .get()
        .then((snap) => {
          snap.forEach((doc) => {
            var activite = doc.data();
            activite.id = doc.id;
            self.activites.push({
              ...activite,
            });
          });
        });
    },

    selectActivite() {
      console.log(this.activite_selected);
    },
    setCampagnes() {
      let self = this;
      let newCampagnes = _.difference(
        this.campagnesExistantesData,
        this.campagnesExistantes
      );

      let campagnes = [];

      _.forEach(newCampagnes, function (ll_parcours_effectif, index) {
        _.forEach(self.groupe.projets, function (projet, index) {
          self.createCampagnes(projet, ll_parcours_effectif);
        });
      });

      this.reset();
    },
    createCampagnes(projet, ll_parcours_effectif) {
      let mois = [
        ll_parcours_effectif + "-01-31",
        ll_parcours_effectif + "-02-28",
        ll_parcours_effectif + "-03-31",
        ll_parcours_effectif + "-04-30",
        ll_parcours_effectif + "-05-31",
        ll_parcours_effectif + "-06-30",
        ll_parcours_effectif + "-07-31",
        ll_parcours_effectif + "-08-31",
        ll_parcours_effectif + "-09-30",
        ll_parcours_effectif + "-10-31",
        ll_parcours_effectif + "-11-30",
        ll_parcours_effectif + "-12-31",
      ];
      let self = this;

      let Activite = _.filter(this.Activites, {
        ll_programme: projet.ll_programme,
      });

      _.forEach(mois, function (ll_mois, index) {
        self.create(projet, ll_parcours_effectif, ll_mois, Activite);
      });
    },
    ...mapActions({
      GetActivites: "Activites/GetAll",
      GetParcoursEffectifsDuGroupe:
        "ParcoursEffectif/GetParcoursEffectifsDuGroupe",
    }),
  },
  computed: {
    computedDateDebutFormattedMomentjs() {
      return this.date_debut
        ? this.$moment(this.date_debut).format("DD-MM-YYYY")
        : "";
    },
    computedDateFinFormattedMomentjs() {
      return this.date_fin
        ? this.$moment(this.date_fin).format("DD-MM-YYYY")
        : "";
    },
    ...mapState({
      bailleurs: (state) => state.Bailleurs.bailleurs,
      Activites: (state) => state.Activites.Activites,
    }),
  },
};
</script>

<style lang="scss" scoped></style>
